// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import { store } from './redux/store';

// const renderApp = () => {
//   if (window.location.pathname !== '/sitemap.xml') {
//     ReactDOM.render(
//       <Provider store={store}>
//         <BrowserRouter>
//           <App />
//         </BrowserRouter>
//       </Provider>,
//       document.getElementById('root')
//     );
//   }else{
//     ReactDOM.render(
//       <Provider store={store}>
//         <BrowserRouter>
//           <App />
//         </BrowserRouter>
//       </Provider>
//     );
//   }


// };

// // Check if the current route is sitemap.xml
// if (window.location.pathname !== '/sitemap.xml') {
//   renderApp();
// }


import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import AnalyticsTracker from './user/components/AnalyticsTracker';

if (window.location.pathname !== '/sitemap.xml') {
 ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <AnalyticsTracker />
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
}

// import React from 'react';
// import ReactDOM from 'react-dom';
// import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import { HelmetProvider } from 'react-helmet-async';

// import App from './App';
// import { store } from './redux/store';
// import AnalyticsTracker from './user/components/AnalyticsTracker';

// ReactDOM.render(
//   <Provider store={store}>
//     <HelmetProvider>
//       <BrowserRouter>
//         <AnalyticsTracker />
//         <App />
//       </BrowserRouter>
//     </HelmetProvider>
//   </Provider>,
//   document.getElementById('root')
// );